/* The existing notification uses the same dialog lifecycle as search/navigation. */
(() => {
  if (customElements.get('cart-notification')) return;

  class CartNotification extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.notification = this.querySelector('#cart-notification');
      if (!this.notification) return;
      const signal = this.controller.signal;
      this.ensureDialog();
      document.addEventListener('raidage:dialog-ready', () => this.ensureDialog(), { signal });
      window.addEventListener('resize', () => {
        if (this.dialog?.active) this.position();
      }, { signal, passive: true });
    }

    disconnectedCallback() {
      this.dialog?.destroy();
      this.dialog = null;
      this.controller?.abort();
      this.controller = null;
    }

    ensureDialog() {
      if (this.dialog || !this.notification || !window.RaidageDialog) return;
      this.dialog = new window.RaidageDialog(this.notification, {
        manageExpanded: false,
        initialFocus: this.notification.querySelector('[data-dialog-close]:not(.raidage-overlay-backdrop)'),
        onOpen: () => {
          this.position();
          this.notification.classList.add('active');
        },
        onClose: () => this.notification.classList.remove('active'),
      });
    }

    position() {
      const header = document.querySelector('[data-header]');
      const bottom = header?.getBoundingClientRect().bottom || 0;
      const top = Math.max(12, Math.min(bottom + 12, window.innerHeight * .25));
      this.notification.style.setProperty('--raidage-cart-top', `${top}px`);
    }

    open() {
      this.ensureDialog();
      if (!this.dialog) throw new Error('Cart feedback is unavailable.');
      this.dialog.open(this.activeElement);
    }

    close() { this.dialog?.close(); }

    renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      const updates = this.getSectionsToRender().map((section) => {
        const target = document.getElementById(section.id);
        if (!target) throw new Error('Cart feedback target is unavailable.');
        return [target, this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)];
      });
      updates.forEach(([target, html]) => { target.innerHTML = html; });
      this.open();
    }

    getSectionsToRender() {
      return [
        { id: 'cart-notification-product', selector: `[id="cart-notification-product-${this.cartItemKey}"]` },
        { id: 'cart-notification-button' },
        { id: 'cart-icon-bubble' },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      if (typeof html !== 'string') throw new Error('Cart feedback response is unavailable.');
      const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      if (!element) throw new Error('Cart feedback response is incomplete.');
      return element.innerHTML;
    }

    setActiveElement(element) { this.activeElement = element; }
  }
  customElements.define('cart-notification', CartNotification);
})();
